export default "__VITE_ASSET__F1OE0$5z__"